import { useAuth as libUseAuth } from "@marekl/adminer";
import type { User } from "./queries";

/** Demo-typed wrapper around `useAuth()` that returns the User. */
export function useAuth() {
  return libUseAuth<User>();
}
